import { computed } from '@vue/composition-api';
import AiQuestion from '@/orm/models/AiInterview/AiQuestion';

export default function useAiInterviewQuestions() {
  const aiQuestions = computed(() => AiQuestion.query().withAllRecursive().get());

  async function getQuestions(vacancyId, payload) {
    AiQuestion.deleteAll();
    await AiQuestion.api().getQuestions(vacancyId, payload);
  }

  async function updateQuestions(vacancyId, payload) {
    AiQuestion.deleteAll();
    await AiQuestion.api().updateQuestions(vacancyId, payload);
  }

  async function confirm(vacancyId, payload) {
    await AiQuestion.api().confirm(vacancyId, payload);
  }

  return {
    aiQuestions,
    getQuestions,
    updateQuestions,
    confirm,
  };
}
